import { createI18n } from 'vue-i18n';
import { Locale } from '../../constants/locales';

export * from './translationService';

const loadLocaleMessages = (locales: Locale[]) => {
  const dictionaryModule: Record<string, { default: any }> = import.meta.glob('/src/Translations/*.json', {
    eager: true,
  });
  const messages = {} as any;
  for (const path in dictionaryModule) {
    if (path) {
      const matched = path.match(/([a-z0-9-_]{2,6})\./i);
      if (matched && matched.length > 1) {
        const locale = matched[1] as Locale;
        if (locales.includes(locale)) {
          const messageData = dictionaryModule[path]?.default;
          if (messageData) {
            messages[locale] = messageData;
          } else {
            console.warn(`Failed to load translation messages for locale: ${locale}`);
          }
        }
      }
    }
  }

  return messages;
};

export const bootstrapI18n = (args: { locale: Locale }) => {
  const allMessages = loadLocaleMessages([args.locale]);
  return createI18n<false>({
    legacy: false,
    locale: args.locale,
    fallbackLocale: args.locale,
    messages: allMessages,
  });
};
